import { gql } from "@apollo/client";

export const GET_DASHBOARD_TASK_STATES = gql`
  query GetDashboardTaskStates {
    task {
      id
      status
      type
      createdAt
      booking {
        id
      }
    }
  }
`;

export const COMPLETE_DASHBOARD_TASK = gql`
  mutation CompleteDashboardTask($id: UUID!) {
    markAsDone(id: $id) {
      id
      status
    }
  }
`;

export const CHECK_DASHBOARD_AVAILABILITY = gql`
  mutation CheckDashboardAvailability($id: UUID!) {
    checkAvailability(id: $id) {
      boatId
      boatName
      hasCalendar
      isAvailableCalendar
      isAvailableBookings
    }
  }
`;

export const MARK_DASHBOARD_MESSAGE_AS_SEEN = gql`
  mutation MarkDashboardMessageAsSeen($id: UUID!) {
    markAsSeen(id: $id) {
      id
      seenOn
    }
  }
`;

export const SUGGEST_DASHBOARD_REPLY = gql`
  mutation SuggestDashboardReply(
    $bookingID: UUID!
    $requestID: UUID!
    $draft: String
  ) {
    suggestBookingReply(
      bookingID: $bookingID
      requestID: $requestID
      draft: $draft
    )
  }
`;
